/** The hamburger icon for mobile. */
const IconHamburgerMobile = (): React.ReactElement => {
  return (
    <>
      <rect x="20%" y="30%" width="9" height="1.5" fill="currentColor" />
      <rect x="20%" y="50%" width="6" height="1.5" fill="currentColor" />
      <rect x="20%" y="70%" width="9" height="1.5" fill="currentColor" />

      <rect
        x="20"
        y="70%"
        width="3"
        height="1.5"
        transform="rotate(45 22 16)"
        fill="currentColor"
      />
      <circle
        cx="70%"
        cy="13"
        r="3.25"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
    </>
  );
};

export default IconHamburgerMobile;
